import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Button,
  Box,
  Container,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import useAuthStore from "../../services/AuthStore";
import { LangContext } from "../../LanguageProvider";
export default function ProfileTeacher() {
  const { translations } = useContext(LangContext);
  const [loading, setLoading] = useState(true);
  const { user, getTeachers } = useAuthStore();
  const [teacher, setTeacher] = useState();
  useEffect(() => {
    const fetchData = async () => {
      if (user.id) {
        const newteacher = await getTeachers(0, user.id);
        setTeacher(newteacher.teacher);
        console.log(newteacher.teacher);
        setLoading(false);
      }
    };
    fetchData();
  }, [user]);

  if (loading) {
    return <>Загрузка</>;
  }

  return (
    <Container
      sx={{
        paddingTop: 5,
        paddingBottom: 5,
      }}>
      <Typography
        variant="h4"
        sx={{
          p: 2,
          color: "#1976d2",
        }}>
        {translations["profile"]}
      </Typography>
      <Card sx={{ margin: "auto", mt: 4, p: 2 }}>
        {/* Заголовок с вкладками */}

        <CardContent>
          <Grid container spacing={2}>
            {/* Аватар */}
            <Grid item xs={12} sm={4} md={3}>
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  bgcolor: "grey.300",
                  margin: "auto",
                }}
              />
            </Grid>

            {/* Данные пользователя */}
            <Grid item xs={12} sm={8} md={9}>
              <Typography variant="body1">
                <strong>E-mail:</strong> {teacher.email}
              </Typography>
              <Typography variant="body1">
                <strong>{translations["lastname"]}:</strong> {teacher.lastname}
              </Typography>
              <Typography variant="body1">
                <strong>{translations["name"]}:</strong> {teacher.name}
              </Typography>
              <Typography variant="body1">
                <strong>{translations["surname"]}:</strong> {teacher.surname}
              </Typography>
              <Typography variant="body1">
                <strong>телефон:</strong> {teacher.phone}
              </Typography>
            </Grid>
          </Grid>

          {/* Кнопки */}
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              color="primary"
              startIcon={<LockIcon />}>
              Сменить пароль
            </Button>
            <Button
              variant="contained"
              color="warning"
              startIcon={<EditIcon />}>
              Редактировать
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
